// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__15-I-","title":"FrontImage_title__xAtSb"};